import { useReadOnly } from 'utils/lifecycle'
import { browserDate } from 'utils/time'
import React, { useState } from 'react';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography,
} from '@mui/material';
import { Edit, Delete} from '@mui/icons-material';
import { useSnackbar } from 'notistack';
import { ConfirmationDialog } from 'components';
import api from 'utils/api';
import { getApiErrorMessage } from 'utils/apiErrors';

const OfferDraft = ({
  draft,
  editDraft,
  onOfferDataRefresh,
}) => {
  const readOnly = useReadOnly()
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleDeleteDraft = async () => {
    setIsDeleting(true);
    try {
      await api.delete(`/drafts/${draft.draftId}`);

      enqueueSnackbar('Draft deleted.', { variant: 'success' });
      onOfferDataRefresh?.(['DRAFT']);
    } catch (error) {
      enqueueSnackbar(getApiErrorMessage(error, 'Couldn’t delete draft. Please try again.'), {
        variant: 'error'
      });
    } finally {
      setIsDeleting(false);
      setShowConfirmation(false);
    }
  };

  return (
    <>
      <Card>
<CardContent style={{ padding: '8px 16px 0' }}>
  <Grid container spacing={3}>
    <Grid item xs={12}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h6">
            {draft?.payload?.offer?.title || 'Untitled draft'}
          </Typography>
        </Grid>
        <Grid item>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          <Typography variant="h7" color="textSecondary">
            Created On: {browserDate(draft?.createdAt).toLocaleString()}
          </Typography>
          <Typography variant="h7" color="textSecondary">
            Last Updated On: {browserDate(draft?.updatedAt).toLocaleString()}
          </Typography>
        </div>
      </Grid>
      </Grid>
      <Typography variant="caption" color="textSecondary">
        Current Step: {draft?.payload?.progress?.currentStep ?? 'N/A'}
      </Typography>
    </Grid>
  </Grid>
</CardContent>
        <CardActions style={{ textAlign: 'right' }}>
          <Button disabled={readOnly}
            color="primary"
            size="small"
            onClick={() => editDraft(draft.draftId)}
          >
            <Edit fontSize="small" style={{ marginRight: 4 }} />
            Edit draft
          </Button>
          <Button
            color="error"
            size="small"
            onClick={() => setShowConfirmation(true)}
            disabled={readOnly || isDeleting}
          >
            <Delete fontSize="small" style={{ marginRight: 4 }} />
            {isDeleting ? 'Deleting...' : 'Delete draft'}
          </Button>
        </CardActions>
      </Card>
      {showConfirmation && (
        <ConfirmationDialog
          onCancel={() => setShowConfirmation(false)}
          onConfirm={handleDeleteDraft}
          isOpen
          body="Are you sure you want to delete this draft?"
          title="Delete draft"
          successButtonLabel={isDeleting ? 'Deleting...' : 'Delete'}
          isProcessing={isDeleting}
        />
      )}
    </>
  );
};

export default OfferDraft;
